import { useEffect, useState } from "react";
import Table from "../../Reusable/Table/Table1";
import {
  UserOutlined,
  EyeOutlined,
  WalletOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  CopyOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import DropdownButton from "../../Reusable/dropdown/Drop";
import ReusableModal from "../../Reusable/Model/Model";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import EditableTable from "../../Reusable/Table/EditableTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Tag,
  message,
  Input,
  Badge,
  Button,
  Form,
  Select,
  Image,
  Segmented,
  Switch,
  Popconfirm, Modal, Progress
} from "antd";
import consts from "../../constant";
import { type } from "@testing-library/user-event/dist/type";
import Loadingpage from "../Loadingpage/Loadingpage";
import ExportButton from "../../Reusable/ExportButton/ExportButton";
const UsersHistory = () => {

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [openBlock, setOpenBlock] = useState(false);
  const [openBlock2, setOpenBlock2] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [loadingSwitchId, setLoadingSwitchId] = useState(null);
  const [formLayout] = useState("vertical");
  const [form] = Form.useForm();
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openViewDrawer, setOpenViewDrawer] = useState(false);
  const [openDeleteDrawer, setOpenDeleteDrawer] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("false");
  const [messageApi, contextHolder] = message.useMessage();
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState(false);
  const [block, setBlock] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(
    "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
  );

  const [wallet, setWallet] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterVerified, setFilterVerified] = useState("");
  const [filter2fa, setFilter2fa] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [searchText, setSearchText] = useState("");
  const [deleteTimer, setDeleteTimer] = useState(5);
  const [isDeleting, setIsDeleting] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const { Search } = Input;

  // const onSearch = (value, _e, info) =>
  //   console.log(info?.source, value, "snakar");

  // const success = () => {
  //   messageApi.open({
  //     type: "success",
  //     content: "Status Updated",
  //   });
  // };

  // const showDrawer = (user) => {

  //   // setSelectedUser(user);
  //   setOpenDrawer(true);
  // };

  const onClose = () => {
    setOpenDrawer(false);
    setSelectedUser(null);
    setOpenViewDrawer(false);
  };

  const progressPercent = (deleteTimer / 5) * 100;

  const startDeleteTimer = () => {
    setIsDeleting(true);
    setDeleteTimer(5);

    const id = setInterval(() => {
      setDeleteTimer((prev) => {
        if (prev <= 0.05) {
          clearInterval(id);
          confirmDelete();
          return 0;
        }
        return +(prev - 0.05).toFixed(2);
      });
    }, 50);

    setIntervalId(id);
  };

  const confirmDelete = () => {
    if (selectedUser) {
      handleDelete(selectedUser.key);
    }
    closeDeleteModal();
  };

  const cancelDelete = () => {
    if (intervalId) { clearInterval(intervalId);  setIntervalId(null); };
    setIsDeleting(false);
    setDeleteTimer(5);
  };

  const closeDeleteModal = () => {
    if (intervalId) clearInterval(intervalId);
    setIsDeleting(false);
    setDeleteTimer(5);
    setOpenDeleteDrawer(false);
  };

  // const showModalBlock = (val) => {
  //   setOpenBlock(true);
  //   setSelectedUser(val);
  //   setStatus(val?.status);
  //   setBlock(val?.block);
  // };

  // const showModalBlock2 = (val) => {

  //   setOpenBlock2(true);
  //   setSelectedUser(val);
  //   setBlock(val?.block);
  //   setStatus(val?.status);
  // };

  // const handleOkBlock = () => {
  //   // setModalText("The modal will be closed after two seconds");
  //   setConfirmLoading(true);
  //   setStatus(!status);
  //   setTimeout(() => {
  //     setOpenBlock(false);
  //     setConfirmLoading(false);
  //     getUserStatus(!status, block);
  //     success();
  //   }, 2000);
  // };

  // const handleOkBlock2 = () => {
  //   // setModalText("The modal will be closed after two seconds");
  //   setConfirmLoading(true);
  //   setBlock(!block);

  //   setTimeout(() => {
  //     setOpenBlock2(false);
  //     setConfirmLoading(false);
  //     getUserStatus(status, !block);

  //     success();
  //   }, 2000);
  // };

  // const handleCancelBlock = () => {
  //   setOpenBlock(false);
  // };

  // const handleCancelBlock2 = () => {
  //   setOpenBlock2(false);
  // };
  // const handleMenuClick = (e, user) => {
  //   console.log("Clicked:", e);
  //   if (e.key === "1") {
  //     // View
  //     showDrawer(user);
  //   }
  //   if (e.key === "2") {
  //     navigate(`/${consts.route}/userwallet`, { state: { user } });
  //   }
  //   if (e.key === "3") {
  //     showModalBlock(user);
  //   }
  //   if (e.key === "4") {
  //     showModalBlock2(user);
  //   }
  // };

  // const items = (user) => [
  //   { label: "View", key: "1", icon: <EyeOutlined /> },
  //   { label: "Wallet", key: "2", icon: <WalletOutlined /> },
  //   {
  //     label: user?.verified !== "true" ? "Verify" : "Un-Verify",
  //     key: "3",
  //     icon: <UserOutlined />,
  //   },
  //   {
  //     label: user?.block ? "Unblock" : "Block", // 👈 dynamic text
  //     key: "4",
  //     icon: <StopOutlined />,
  //   },
  // ];

  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },
    {
      title: "Profile Image",
      dataIndex: "profile_image",
      key: "profile_image",
      render: (_, record) => {
        return record?.profile_image ? (
          <Image
            width={40}
            height={40}
            style={{
              borderRadius: "50%",
              objectFit: "cover",
              border: "1px solid #FC4420",
              cursor: "pointer",
            }}
            src={record?.profile_image}
            preview={{
              mask: "Click to Preview",
            }}
          />
        ) : (
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              border: "1px solid #FC4420",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#FC4420",
              fontWeight: "bold",
              fontSize: "18px",
              textTransform: "uppercase",
            }}
          >
            {record?.name?.charAt(0) || "U"}
          </div>
        );
      },
    },

    { title: "Name", dataIndex: "name", key: "name", searchable: true },
    { title: "Email", dataIndex: "email", key: "email" },
    // { title: "User ID", dataIndex: "userId", key: "userId" },
    { title: " OTP Verified", dataIndex: "verified", key: "verified" },
    { title: "Created At", dataIndex: "createdAt", key: "createdAt" },
    { title: "Updated At", dataIndex: "updatedAt", key: "updatedAt" },
    { title: "2FA Status", dataIndex: "f2A_Status", key: "f2A_Status" },
    {
      title: "Trade Status", dataIndex: "trade_status", key: "trade_status",
      render: (trade_status, record) => {
        return (
          <Switch
            checked={trade_status === "true"}
            loading={loadingSwitchId === record.key}
            disabled={loadingSwitchId === record.key}
            onChange={(checked) => handleTradeStatusChange(checked, record)}
            checkedChildren={<span style={{ color: "#000", fontWeight: "500" }}>Active</span>}
            unCheckedChildren={<span style={{ color: "#000", fontWeight: "500" }}>Inactive</span>}
            style={{
              backgroundColor: trade_status === "true" ? "#81f26f" : "#ff4d4f",
            }}
          />
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <Switch
          checked={status === "true"}
          loading={loadingSwitchId === record.key}
          disabled={loadingSwitchId === record.key}
          onChange={(checked) => handleStatusChange(checked, record)}
          checkedChildren={<span style={{ color: "#000", fontWeight: "500" }}>Active</span>}
          unCheckedChildren={<span style={{ color: "#000", fontWeight: "500" }}>Inactive</span>}
          style={{
            backgroundColor: status === "true" ? "#81f26f" : "#ff4d4f",
          }}
        />
      )
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          danger
          icon={<DeleteOutlined />}
          onClick={() => {
            setSelectedUser(record);
            setOpenDeleteDrawer(true);
          }}
        >
          Delete
        </Button>
      )
    }
  ];

  const handlePagination = (pagination) => {
    console.log("Table params:", pagination);
    setPage(pagination);
  };

  const handleView = async (record) => {
    setSelectedUser(record);
    setSelectedStatus(record?.status);
    form.setFieldsValue({
      username: record?.name,
      status: record?.status === "true" ? "Active" : "In-Active",
    });

    try {
      const response = await axios.post(
        `${consts.BackendUrl}/users/getWallet`,
        { user_id: record.key },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response?.data?.success) {
        const resultData = response?.data?.result;
        const walletArray = Array.isArray(resultData) ? resultData : (resultData ? [resultData] : []);
        form.setFieldsValue({
          type: walletArray[0]?.type,
          balance: walletArray[0]?.balance,
          profit: walletArray[0]?.profit,
          escrow_balance: walletArray[0]?.escrow_balance,
        });
        setWallet(walletArray);
        setOpenViewDrawer(true);
      } else {
        form.setFieldsValue({
          balance: 0,
        });
        // form.resetFields([ "balance"]);
        setWallet([]);
        // setSelectedUser(null);
        setOpenViewDrawer(true);
      }
    } catch (error) {
      form.resetFields();
      setSelectedUser(null);
      setWallet([]);
      console.log(error);
    }
  };

  const handleStatusChange = async (checked, record) => {
    try {
      setLoadingSwitchId(record.key);
      const response = await axios.patch(
        `${consts.BackendUrl}/users/update/${record.key}`,
        {
          id: record.key,
          status: checked ? "true" : "false",
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response?.data?.success || response?.status === 200) {
        messageApi.open({
          type: "success",
          content: "Status updated successfully",
        });
        getUsers();
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to update status",
        });
      }
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.message || "Failed to update status",
      });
    } finally {
      setLoadingSwitchId(null);
    }
  };

  const handleTradeStatusChange = async (checked, record) => {
    try {
      setLoadingSwitchId(record.key);
      const response = await axios.post(
        `${consts.BackendUrl}/trade-status`,
        {
          userId: record.key,
          trade_status: checked ? "true" : "false",
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (response?.data?.success || response?.status === 200) {
        messageApi.open({
          type: "success",
          content: "Trade status updated successfully",
        });
        getUsers();
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to update trade status",
        });
      }
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.message || "Failed to update trade status",
      });
    } finally {
      setLoadingSwitchId(null);
    }
  };

  const handleDelete = async (id) => {
    try {
      setConfirmLoading(true);
      const response = await axios.delete(`${consts.BackendUrl}/users/${id}`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
        },
      });
      if (response.data.success || response.status === 200) {
        messageApi.success("User deleted successfully");
        getUsers();
      } else {
        messageApi.error("Failed to delete user");
      }
    } catch (error) {
      console.error(error);
      messageApi.error(error?.response?.data?.message || "Error deleting user");
    } finally {
      setConfirmLoading(false);
    }
  };

  const getUsers = async (searchVal = searchText, vFilter = filterVerified, f2aFilter = filter2fa, sFilter = filterStatus) => {
    try {
      setConfirmLoading(true);
      const { data } = await axios.get(
        `${consts.BackendUrl}/users/getusers`,
        {
          params: {
            search: searchVal,
            page: page?.current ? page?.current : 1,
            limit: page?.pageSize ? page?.pageSize : 10,
            verified: vFilter,
            f2A_Status: f2aFilter,
            status: sFilter,
          },
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );
      if (data?.result?.docs?.length > 0 || data?.docs?.length > 0) {
        var dts = await (data?.result?.docs || data?.docs);

        // Map backend data into the table format
        setTotal(data?.result?.pagination?.total || data?.total || 0);
        const mappedData = await dts.map((user, index) => ({
          key: user._id, // must be uniqueoffset={[10, 10]}
          sno: page?.current
            ? (page?.current - 1) * page?.pageSize + index + 1
            : index + 1,
          profile_image: user?.profile_image,

          name: user?.name,
          // <Badge
          //   count={
          //     user?.block ? <StopOutlined style={{ color: "#f5222d" }} /> : 0
          //   }
          //   offset={[15, 7]}
          // >
          // </Badge>
          email: user?.email,
          // phone: user?.phone,
          // ref: user?.referral_code,
          // status:
          //   user?.verified == "true" ? (
          //     <Tag icon={<CheckCircleOutlined />} color="success">
          //       Verified
          //     </Tag>
          //   ) : (
          //     <Tag icon={<ExclamationCircleOutlined />} color="warning">
          //       Un-Verified
          //     </Tag>
          //   ),
          // select: (
          //   <DropdownButton
          //     items={items(user)}
          //     label="More"
          //     onMenuClick={(e) => {
          //       handleMenuClick(e, user);
          //       setStatus(JSON.parse(user?.verified));
          //     }}
          //   />
          // ),
          verified: user?.verified === "true" ? (
            <Tag color="success">Yes</Tag>
          ) : (
            <Tag color="warning">No</Tag>
          ),
          createdAt: user?.createdAt ? new Date(user?.createdAt).toLocaleDateString() : "-",
          updatedAt: user?.updatedAt ? new Date(user?.updatedAt).toLocaleDateString() : "-",
          f2A_Status: user?.f2A_Status === "true" ? (
            <Tag color="success">Enabled</Tag>
          ) : (
            <Tag color="error">Disabled</Tag>
          ),
          statusText: user?.status === "true" ? (
            <Tag color="success">Active</Tag>
          ) : (
            <Tag color="error">In-Active</Tag>
          ),
          trade_status: user?.trade_status,
          status: user?.status,
          // userId: (user?._id || user?.user_id) ? (
          //   <>
          //     {(user?._id || user?.user_id)?.slice(-6)}{" "}
          //     <CopyOutlined
          //       onClick={() =>
          //         navigator.clipboard
          //           .writeText(user?._id || user?.user_id)
          //           .then(() => {
          //             messageApi.open({
          //               type: "success",
          //               content: "Copied to clipboard",
          //             });
          //           })
          //           .catch((err) => {
          //             messageApi.open({
          //               type: "error",
          //               content: "Failed to copy",
          //             });
          //             console.error("Failed to copy: ", err);
          //           })
          //       }
          //     />
          //   </>
          // ) : (
          //   "-"
          // ),
        }));

        setUsers(mappedData);
        setConfirmLoading(false);
      } else {
        setUsers([]);
        setTotal(0);
        setConfirmLoading(false);
      }
    } catch (error) {
      console.log(error?.response?.data?.message);
      setUsers([]);
      setTotal(0);
      setConfirmLoading(false);
    }
  };

  // const getUserStatus = async (status, block) => {
  //   try {
  //     const { data } = await axios.post(
  //       `${consts.BackendUrl}/admin/updateuserverifydetails`,
  //       {
  //         status: status,
  //         userId: selectedUser?._id,
  //         email_verify: selectedUser?.email_verify,
  //         kyc_verify: selectedUser?.kyc_verify,
  //         f2A_Status: selectedUser?.f2A_Status,
  //         block: block,
  //       },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
  //         },
  //       }
  //     );
  //     if (data?.status === true) {
  //       getUsers();
  //       // setStatus();
  //     } else {
  //       // setTwoFa(false);
  //       // handleClose();
  //     }
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };

  //   useEffect(() => {
  //     getUsers();
  //   }, []);

  const onFinish = async (values) => {
    try {
      if (values?.balance <= 0) {
        return messageApi.open({
          type: "error",
          content: "Wallet balance should be greater than 0",
        });
      }
      console.log(selectedUser?.status, values?.status, "oudijdjd");
      if (
        selectedUser?.status != (values?.status === "Active" ? "true" : "false")
      ) {
        const response = await axios.patch(
          `${consts.BackendUrl}/users/update/${selectedUser?.key}`,
          {
            id: selectedUser?.key,
            status: values?.status === "Active" ? "true" : "false",
          },
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
            },
          }
        );
      }
      const response = await axios.post(
        `${consts.BackendUrl}/updateUserWallet`,
        {
          userid: selectedUser?.key,
          walletBalance: values?.balance,
        },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );

      if (response?.data?.success) {
        messageApi.open({
          type: "success",
          content: "Updated successfully",
        });
        getUsers();
        setOpenViewDrawer(false);
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to update",
        });
      }
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: "error",
        content: error?.response?.data?.message || "Failed to update wallet",
      });
    }
  };

  const onChange = async (e) => {
    const filterWalletByType = wallet?.filter((item) => {
      return e === item?.type;
    });

    form.setFieldsValue({
      type: e,
      balance: filterWalletByType?.[0]?.balance || 0,
    });
  };

  useEffect(() => {
    // 🧪 Dummy test data
    getUsers(searchText, filterVerified, filter2fa, filterStatus);
  }, [page.current]);

  return (
    // user
    <>

      <Loadingpage />
      <div className="display-2 p-10">
        <h2>Users </h2>
        <div className="display-1">
          <Search
            placeholder="Search for name"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onSearch={(e) => {
              setPage((prev) => {
                return { ...prev, current: 1 };
              });
              getUsers(e, filterVerified, filter2fa, filterStatus);
            }}
            allowClear
            style={{ width: 200 }}
            loading={confirmLoading}
            className="input-cls"
          />
          <Select
            allowClear
            placeholder="OTP Verified"
            style={{ width: 120, marginLeft: 10 }}
            value={filterVerified || undefined}
            disabled={confirmLoading}
            onChange={(val) => {
              setFilterVerified(val || "");
              setPage((prev) => ({ ...prev, current: 1 }));
              getUsers(searchText, val || "", filter2fa, filterStatus);
            }}
          >
            <Select.Option value="true">Yes</Select.Option>
            <Select.Option value="false">No</Select.Option>
          </Select>
          <Select
            allowClear
            placeholder="2FA Status"
            style={{ width: 120, marginLeft: 10 }}
            value={filter2fa || undefined}
            disabled={confirmLoading}
            onChange={(val) => {
              setFilter2fa(val || "");
              setPage((prev) => ({ ...prev, current: 1 }));
              getUsers(searchText, filterVerified, val || "", filterStatus);
            }}
          >
            <Select.Option value="true">Enable</Select.Option>
            <Select.Option value="false">Disable</Select.Option>
          </Select>
          <Select
            allowClear
            placeholder="Status"
            style={{ width: 120, marginLeft: 10 }}
            value={filterStatus || undefined}
            disabled={confirmLoading}
            onChange={(val) => {
              setFilterStatus(val || "");
              setPage((prev) => ({ ...prev, current: 1 }));
              getUsers(searchText, filterVerified, filter2fa, val || "");
            }}
          >
            <Select.Option value="true">Active</Select.Option>
            <Select.Option value="false">Inactive</Select.Option>
          </Select>

          <Button
            style={{ marginLeft: 10 }}
            disabled={confirmLoading}
            icon={<CloseCircleOutlined />}
            onClick={() => {
              setSearchText("");
              setFilterVerified("");
              setFilter2fa("");
              setFilterStatus("");
              setPage((prev) => ({ ...prev, current: 1 }));
              getUsers("", "", "", "");
            }}
          >
            Clear
          </Button>

          <ExportButton
            category="users"
            filters={{
              search: searchText,
              page: page?.current ? page?.current : 1,
              limit: page?.pageSize ? page?.pageSize : 10,
              verified: filterVerified,
              f2A_Status: filter2fa,
              status: filterStatus,
            }}
          // fields={fields} 
          />
        </div>
      </div>
      <EditableTable
        columnsConfig={userColumns}
        dataSource={users}
        className="mt-20"
        total={total} // 👈 pass backend total here
        pageSize={10}
        current={page?.current ? page?.current : 1}
        closeDisabled={true}
        onChange={handlePagination}
      // completeTrade={editTrade}
      // newValues={newValues}
        loading={confirmLoading}  

      />

      {/* <ReusableModal
        title="Update Status"
        open={openBlock}
        onOk={handleOkBlock}
        confirmLoading={confirmLoading}
        onCancel={handleCancelBlock}
        className="table-clr"
      >
        <p>
          Are you sure you want to{" "}
          {selectedUser?.verified == "true" ? (
            <Tag icon={<ExclamationCircleOutlined />} color="warning">
              Un Verify
            </Tag>
          ) : (
            <Tag icon={<CheckCircleOutlined />} color="success">
              Verify
            </Tag>
          )}{" "}
          <strong>{selectedUser?.name} ?</strong>
        </p>
      </ReusableModal>

      <ReusableModal
        title="Update Status"
        open={openBlock2}
        onOk={handleOkBlock2}
        confirmLoading={confirmLoading}
        onCancel={handleCancelBlock2}
        className="table-clr"
      >
        <p>
          Are you sure you want to {selectedUser?.block ? "UnBlock" : "Block"}
          <strong> {selectedUser?.name} ?</strong>
        </p>
      </ReusableModal>

      <ReusableDrawer
        open={openDrawer}
        onClose={onClose}
        title="User Profile"
        className="table-clr"
      >
        {selectedUser ? (
          <div>
            <p>
              <b>Name:</b> {selectedUser.name}
            </p>
            <p>
              <b>Email:</b> {selectedUser.email}
            </p>
            <p>
              <b>Phone:</b> {selectedUser.phone}
            </p>
            <p>
              <b>Referral Code:</b> {selectedUser.referral_code}
            </p>
            <p>
              <b>Status:</b>{" "}
              {selectedUser.email_verify == "true" ? (
                <Tag icon={<CheckCircleOutlined />} color="success">
                  Verified
                </Tag>
              ) : (
                <Tag icon={<ExclamationCircleOutlined />} color="warning">
                  Un-Verified
                </Tag>
              )}
            </p>
          </div>
        ) : (
          <p>No user selected</p>
        )}
      </ReusableDrawer> */}

      <ReusableDrawer
        open={openViewDrawer}
        onClose={onClose}
        title="View"
        extra={<CloseCircleOutlined className="cursor" onClick={onClose} />}
      >
        <Form
          layout={formLayout}
          form={form}
          onFinish={onFinish}
          style={{ maxWidth: 600 }}
        >
          <Form.Item label="Username" name="username">
            <Input style={{ width: "100%" }} type="text" readOnly />
          </Form.Item>
          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Please select type" }]}
          >
            <Select placeholder="Select type" name="type" onChange={onChange}>
              {/* <Select.Option value="Crypto">Crypto</Select.Option>
              <Select.Option value="Stablecoin">Stablecoin</Select.Option>
              <Select.Option value="Token">Token</Select.Option>
              <Select.Option value="NFT">NFT</Select.Option> */}
              <Select.Option value="USD">USD</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="Balance" name="balance">
            <Input style={{ width: "100%" }} type="number" />
          </Form.Item>
          <Form.Item name="status" label="Status">
            <Segmented options={["Active", "In-Active"]} />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </ReusableDrawer>

      <Modal
        open={openDeleteDrawer}
        onCancel={closeDeleteModal}
        footer={null}
        centered
        closable={!isDeleting}
        maskClosable={false}
        title={
          <span style={{ color: "#ff4d4f", fontWeight: 600 }}>
            ⚠ Confirm Deletion
          </span>
        }
        maskStyle={{
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        }}
        styles={{
          content: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",

          },
          header: {
            backgroundColor: "transparent",
          },
        }}
      >
        {/* <div style={{ textAlign: "center", padding: "10px 0" }}>

          <p style={{ fontSize: "16px", fontWeight: 500,color: "#fff" }}>
            Are You Sure You Want To Delete This User?
          </p>

          <p style={{ color: "#ff4d4f", fontWeight: 600 }}>
            Wallet and other related transactions will be deleted permanently.
          </p>

          {isDeleting && (
            <p style={{ marginTop: 10 }}>
              Deleting in <b>{deleteTimer.toFixed(2)}s</b>...
            </p>
          )}

          <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 10 }}>

            <Button onClick={cancelDelete} disabled={!isDeleting}
>
              Cancel
            </Button>

            {!isDeleting ? (
              <Button type="primary" danger onClick={startDeleteTimer}>
                Confirm
              </Button>
            ) : (
              <Button type="primary" danger disabled>
                Deleting...
              </Button>
            )}

           

          </div>
        </div> */}
        <div style={{ textAlign: "center", padding: "10px 0" }}>

          <p className="delete-warning" style={{ color: "#fff", fontWeight: 600 }}>
            Are You Sure You Want To Delete This User?
          </p>

          <p className="delete-danger" style={{ color: "#ff4d4f", fontWeight: 600 }}>
            Wallet and other related transactions will be deleted permanently.
          </p>

          {isDeleting && (
            <>
              <p className="countdown-text">
                Deleting in <b>{deleteTimer.toFixed(2)}s</b>
              </p>

              <Progress
                percent={progressPercent}
                showInfo={false}
                strokeColor="#ff4d4f"
              />
            </>
          )}

          <div style={{ marginTop: 20, display: "flex", justifyContent: "center", gap: 10 }}>

            <Button onClick={cancelDelete} disabled={!isDeleting} 
              style={{
                opacity: 1, // 👈 important
                color: "#ff4d4f",
                borderColor: "#ff4d4f",
                background: "transparent",
                cursor: !isDeleting ? "not-allowed" : "pointer"
              }}
            >
              Cancel
            </Button>

            {!isDeleting ? (
              <Button type="primary" danger onClick={startDeleteTimer}>
                Confirm
              </Button>
            ) : (
              <Button type="primary" danger disabled>
                Deleting...
              </Button>
            )}

          </div>
        </div>
      </Modal>
      
      {contextHolder}
    </>
  );
};

export default UsersHistory;
